export const PlotEndpoint = {
  getPlotDetails: `/admin/propertiesAll?`,
  modifyStatus: `/admin/disableProperty?propertyId=`,
  addPlot: `/admin/listProperty`,
  editPlot: `/admin/Updateproperty/`,
  deletePlot: `/admin/deleteProperty?propertyId=`,
  deleteImageAPI: `/admin/deleteImages?imageId=`,
  uploadImageAPI: `/admin/editImage?imageId=`,
  getPlotDetailsbyId: `/admin/getProperty?propertyId=`,
};
